module.exports = __webpack_public_path__ + "img/13.691bbc2e.jpg";